'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));

const Html = ({
  children,
  format,
  lang
}) => React__default.createElement("html", __chunk_1.extends({}, format ? {
  [format]: ''
} : {}, {
  lang: lang
}), children);

Html.defaultProps = {
  children: undefined,
  format: 'amp',
  lang: 'en'
};
Html.propTypes = {
  children: PropTypes.node,
  format: PropTypes.oneOf(['amp', 'amp4ads', 'amp4email']),
  lang: PropTypes.string
};

exports.default = Html;
//# sourceMappingURL=Html.js.map
